export default __webpack_public_path__ + "static/media/2.88cb1800.png";